export default "__VITE_ASSET__DPM1yOjU__"